const unknownItemDepartmentData = JSON.parse(sessionStorage.getItem('unknownItemDepartmentData'));
const { tradeinDepartments } = unknownItemDepartmentData;
if (!tradeinDepartments || tradeinDepartments.length === 0) {
  window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-search-2`);
}

const departmentSelect = document.getElementById('department-select');
const categorySelect = document.getElementById('category-select');
const subcategorySelect = document.getElementById('subcategory-select');
const subcategoryLabel = document.querySelector('.item-subcategory-label');
const subcategorySelectWrapper = document.querySelector('.item-subcategory-label + .select');
const lookupButton = document.getElementById('trade-in-alternative-lookup-button');
let currentlySelectedDepartment = null;
let currentlySelectedCategory = null;
let currentlySelectedSubcategory = null;

function enableLookupButton(event) {
  return lookupButton.disabled = !event.target.value;
}

function resetSelectElement({ element, defaultText }) {
  element.disabled = true;
  element.value = '';
  element.replaceChildren();
  const defaultOption = document.createElement('option');
  defaultOption.textContent = defaultText;
  defaultOption.value = '';
  defaultOption.selected = true;
  defaultOption.disabled = true;
  element.appendChild(defaultOption);
}

function renderSelectOption({ element, value, textContent }) {
  const categoryOption = document.createElement('option');
  categoryOption.textContent = textContent;
  categoryOption.classList.add('category-option');
  categoryOption.value = value;
  element.appendChild(categoryOption);
  element.disabled = false;
}

function handleSelectDepartment(event) {
  const {
    selectCategory,
    selectSubcategory,
  } = TRADE_IN_ALTERNATIVE_LOOKUP_CONFIG;
  resetSelectElement({ element: categorySelect, defaultText: selectCategory });
  resetSelectElement({ element: subcategorySelect, defaultText: selectSubcategory });
  const selectedDepartment = tradeinDepartments.find(
    department => department.name === event.target.value,
  );
  currentlySelectedDepartment = selectedDepartment;

  selectedDepartment.categories.forEach((category) => {
    renderSelectOption({
      element: categorySelect,
      value: category.name,
      textContent: category.displayName,
    });
  });
};

function handleSelectCategory(event) {
  const selectedCategory = currentlySelectedDepartment.categories.find(
    category => category.name === event.target.value,
  );
  currentlySelectedSubcategory = selectedCategory;

  if (!currentlySelectedSubcategory.subcategories) {
    enableLookupButton(event);
  } else {
    setupSubcategorySelect(currentlySelectedSubcategory);
  }
};

function setupSubcategorySelect() {
  const {
    selectSubcategory,
  } = TRADE_IN_ALTERNATIVE_LOOKUP_CONFIG;
  resetSelectElement({ element: subcategorySelect, defaultText: selectSubcategory });
  currentlySelectedSubcategory.subcategories.forEach((subcategory) => {
    renderSelectOption({
      element: subcategorySelect,
      value: subcategory.name,
      textContent: subcategory.displayName,
    });
  });
}

function submitUnknownItem() {
  const selectedDepartmentName = departmentSelect.value;
  const selectedCategoryName = categorySelect.value;
  const selectedSubcategoryName = subcategorySelect?.value;

  const selectedDepartment = tradeinDepartments.find(
    department => department.name === selectedDepartmentName,
  );
  const selectedCategory = selectedDepartment.categories.find(
    category => category.name === selectedCategoryName,
  );
  const selectedSubcategory = selectedSubcategoryName ?
    selectedCategory.subcategories.find(
      subcategory => subcategory.name === selectedSubcategoryName,
    ) :
    null;
  
  const submittedUnknownItemConditions = (selectedSubcategory || selectedCategory).conditions;

  const currentTradeinItem = {
    department: selectedDepartmentName,
    departmentDisplay: selectedDepartment.displayName,
    category: selectedCategoryName,
    categoryDisplay: selectedCategory.displayName,
    subcategory: selectedSubcategoryName,
    subcategoryDisplay: selectedSubcategory?.displayName,
    isUnknown: true,
    submittedUnknownItemConditions,
    rubricCode: selectedCategory.rubricCode,
  };

  sessionStorage.setItem('currentTradeinItem', JSON.stringify(currentTradeinItem));

  window.location = appendReferrerToUrl(`${Shopify.routes.root}pages/trade-in-eligibility`);
};

document.addEventListener('DOMContentLoaded', () => {
  const {
    selectDepartment,
  } = TRADE_IN_ALTERNATIVE_LOOKUP_CONFIG;
  resetSelectElement({ element: departmentSelect, defaultText: selectDepartment });
  tradeinDepartments.forEach((department) => {
    renderSelectOption({
      element: departmentSelect,
      value: department.name,
      textContent: department.displayName,
    });
  });
  if (tradeinDepartments.some(department => department.categories.some(
    category => category.subcategories,
  ))) {
    subcategoryLabel.classList.remove('hidden');
    subcategorySelectWrapper.classList.remove('hidden');
  }
});

departmentSelect.addEventListener('change', handleSelectDepartment);
categorySelect.addEventListener('change', handleSelectCategory);
subcategorySelect.addEventListener('change', enableLookupButton);
lookupButton.addEventListener('click', submitUnknownItem);
